import Box from '@/components/UI/box/Box';
import ProductCardRating from '../_reusable/productCardRating/ProductCardRating';
import Typography from '@/components/UI/typography/Typography';
import ProductCardMap from '../_reusable/productCardMap/ProductCardMap';
import Divider from '@/components/UI/divider/Divider';
import { ProductListRecord } from '../types';
import { FC } from 'react';
import styles from './ProductCardShortTerm.module.scss';
import Link from 'next/link';
interface ProductCardShortTermProps {
  data: ProductListRecord;
  index?: number;
  cardHref: {
    pathname: string;
    query: {
      mid_term?: number | undefined;
      search_id?: string | undefined;
      cancel_link_type?: string | string[] | undefined;
    };
  };
  isCarousel?: boolean;
  redirectLink?: string;
  handleOpenHouse: VoidFunction;
}
const ProductCardShortTerm: FC<ProductCardShortTermProps> = ({
  data,
  index,
  cardHref,
  isCarousel,
  redirectLink,
  handleOpenHouse
}) => {
  const locationText = `${data?.location?.city}${data?.location?.distance ? `، ${data?.location?.distance} کیلومتر فاصله ` : `${data?.location?.village ? `، ${data?.location?.village}` : ''}`}`;
  const maxTotalBedsText = data?.total_beds > 0 ? `${data?.total_beds} جای‌خواب` : 'بدون جای‌خواب';
  return <>
      <Link href={cardHref} data-house-id={data?.id} data-index={index} as={redirectLink} className={styles['link']} data-sentry-element="Link" data-sentry-source-file="ProductCardShortTerm.tsx">
        <Box className={styles['details_info']} data-sentry-element="Box" data-sentry-source-file="ProductCardShortTerm.tsx">
          <ProductCardRating rank={data?.rank} reviews={data?.reviews} data-sentry-element="ProductCardRating" data-sentry-source-file="ProductCardShortTerm.tsx" />
        </Box>

        <Typography variant="bodyL_Bold" className={styles['title']} component="h2" data-sentry-element="Typography" data-sentry-source-file="ProductCardShortTerm.tsx">
          {data?.title}
        </Typography>
      </Link>
      <Box className={styles['description_container']} data-sentry-element="Box" data-sentry-source-file="ProductCardShortTerm.tsx">
        <Box className={styles['accommodates_section']} data-sentry-element="Box" data-sentry-source-file="ProductCardShortTerm.tsx">
          <Typography variant={'bodyM'} className={styles['accommodates_text']} onClick={handleOpenHouse} data-sentry-element="Typography" data-sentry-source-file="ProductCardShortTerm.tsx">{`${data?.rooms > 0 ? ` ${data?.rooms} اتاق ، ` : ''}${maxTotalBedsText} ، تا ${data?.max_accommodates} مهمان `}</Typography>
          <Divider orientation="vertical" data-sentry-element="Divider" data-sentry-source-file="ProductCardShortTerm.tsx" />
          <ProductCardMap location={data?.location} id={data?.id} isCarousel={isCarousel} title={locationText} data-sentry-element="ProductCardMap" data-sentry-source-file="ProductCardShortTerm.tsx" />
        </Box>
      </Box>
    </>;
};
export default ProductCardShortTerm;